import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import callrecorderUrls from "../../configs/callrecorder/callrecorderUrls";
import { UserNumberInterface } from '../../store/callrecorder/userNumbersSlice';

const PREFIX = 'callrecorder';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: callrecorderUrls.userNumberPath(value.id)
  };
}

export const userNumbersEntity = new schema.Entity(
  'userNumbers',
  {},
  {
    processStrategy
  }
);

export const userNumberEntity = new schema.Entity(
  'userNumber',
  {},
  {
    processStrategy
  }
);

const fetchUserNumbersCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params })
  const normalized = normalize<
    any,
    {
      userNumbers: { [key: string]: UserNumberInterface };
    }
  >(response.data.user_numbers, [userNumbersEntity]);

  return {
    userNumbers: normalized.entities?.userNumbers || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { userNumber: UserNumberInterface; }
  >(response.data.user_number, userNumberEntity);
  return normalized.entities;
}

export const fetchUserNumbers = createAsyncThunk(
  `${PREFIX}_userNumbers/fetchUserNumbers`,
  async (params: object = {}) => fetchUserNumbersCollection('/onesky/user_numbers', params)
);

export const fetchUserNumber = createAsyncThunk(
  `${PREFIX}_userNumbers/fetchUserNumber`,
  async (id: number | string) => {
    const response = await callrecorderApi.get(`/onesky/user_numbers/${id}`);
    return normalizeInstance(response);
  }
);
